import { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import CheckInDate from '../components/check-in-date';
import AttendeesList from '../components/attendees-list';
import AttendeeForm from '../components/attendee-form';
import { useUserContext } from '../lib/users-context';
import { useAppContext } from '../lib/app-context';

const CheckInPage = () => {
  const { isAdmin } = useUserContext();
  const { adminMode, setAdminMode } = useAppContext();
  const [adding, setAdding] = useState(false);
  const [isTogglingAdminMode, setIsTogglingAdminMode] = useState(false);

  // Toggling admin mode triggers a heavy rerender (a Select dropdown is
  // rendered for every visible attendee row). Sequence the work so the
  // disabled toggle + spinner paint BEFORE the heavy render runs, then
  // clear the spinner after the render commits.
  const handleToggleAdminMode = (newValue: boolean) => {
    setIsTogglingAdminMode(true);
    setTimeout(() => {
      setAdminMode(newValue);
      setTimeout(() => setIsTogglingAdminMode(false), 0);
    }, 0);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
          gap: 2,
        }}
      >
        <Typography variant='h5'>Check-in</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {isAdmin && (
            <FormControlLabel
              control={
                <Switch
                  size='small'
                  checked={adminMode}
                  disabled={isTogglingAdminMode}
                  onChange={(e) => handleToggleAdminMode(e.target.checked)}
                />
              }
              label={
                <Typography variant='body2'>Group edit mode</Typography>
              }
              sx={{ mr: 1 }}
            />
          )}
          <Button
            variant='contained'
            startIcon={<Add />}
            onClick={() => setAdding(true)}
          >
            Add attendee
          </Button>
        </Box>
      </Box>

      <CheckInDate />
      <AttendeesList />
      <Box sx={{ mb: 2 }} />

      <Dialog
        open={adding}
        onClose={() => setAdding(false)}
        fullWidth
      >
        <DialogTitle>Add attendee</DialogTitle>
        <DialogContent>
          {adding && (
            <AttendeeForm
              attendee={null}
              onClose={() => setAdding(false)}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CheckInPage;
